import React, { useCallback } from "react";
import T from "prop-types";
import { Collapse } from "react-bootstrap";
import isFunction from "lodash/isFunction";

import { COMPANY, CUSTOMER, DROPSHIP } from "./shippingTypes";
import ShipToCustomerAddress from "./ShipToCustomerAddress";
import ShipToCompany from "./ShipToCompany";
import ShipToOther from "./ShipToOther";

export default function ShipToFields({
  copyBillingAddress,
  getFieldValue,
  shipToCustomer,
  setFieldValue,
  setFOB,
  shipToCompany,
  shipToType,
  setShippingToAddress
}) {
  const onChangeAddress = useCallback(
    allowedShipToType => address => {
      if (
        isFunction(setShippingToAddress) &&
        shipToType === allowedShipToType
      ) {
        const onChange = setShippingToAddress(shipToType);

        onChange(address);
      }
    },
    [shipToType, setShippingToAddress]
  );

  if (!shipToType) {
    return [];
  }

  return [
    <Collapse in={shipToType === CUSTOMER} key={CUSTOMER}>
      <div>
        <ShipToCustomerAddress
          copyBillingAddress={copyBillingAddress}
          company={shipToCustomer}
          setFieldValue={(field, val) => setFieldValue(field)(val)}
          getField={getFieldValue}
          setFOB={setFOB}
          onChangeAddress={onChangeAddress(CUSTOMER)}
        />
      </div>
    </Collapse>,
    <Collapse in={shipToType === COMPANY} key={COMPANY}>
      <div>
        <ShipToCompany
          company={shipToCompany}
          setFOB={setFOB}
          getField={getFieldValue}
          onChangeAddress={onChangeAddress(COMPANY)}
        />
      </div>
    </Collapse>,
    <Collapse in={shipToType === DROPSHIP} key={DROPSHIP}>
      <div>
        <ShipToOther
          key={shipToType}
          setFOB={setFOB}
          getField={getFieldValue}
        />
      </div>
    </Collapse>
  ];
}
ShipToFields.propTypes = {
  getFieldValue: T.func,
  shipToCompany: T.instanceOf(Object),
  shipToCustomer: T.instanceOf(Object),
  setFOB: T.func,
  setShippingToAddress: T.func,
  shipToType: T.string.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/ShippingSection/ShipToFields.jsx